import { render } from "./LoadingScreen.vue?vue&type=template&id=265a2c2c&scoped=true"
const script = {}

import "./LoadingScreen.vue?vue&type=style&index=0&id=265a2c2c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-265a2c2c"]])

export default __exports__